
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"2","y":"2","width":"20","height":"20","rx":"4","fill":"#B76538"}}),_c('path',{attrs:{"d":"M9.43 12.532a1.806 1.806 0 11-.014-1.111h5.168a1.806 1.806 0 11-.015 1.11H9.431z","fill":"#fff"}})])
          )
        }
      }
    